import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import { getOwners, getUdderAnimals, getUdders, getUserRole, updateUdder, deleteUdder } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select";
import Spinner from "../../components/Spinner";
import { Typography, Box, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AreYouSurePopup from "../../components/popups/AreYouSurePopup.js";
import { BackButton } from "../../components/Buttons.js";

const UdderEdit = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [fetchedAnimals, setFetchedAnimals] = useState([]);
    const [selectedAnimal, setSelectedAnimal] = useState();
    const [animalsDropdownValues, setAnimalsDropdownValues] = useState([]);
    const [step, setStep] = useState(1);
    const [fetchedUdders, setFetchedUdders] = useState([]);
    const [uddersDropdownValues, setUddersDropdownValues] = useState([]);
    const [selectedUdder, setSelectedUdder] = useState();
    const [userRole, setUserRole] = useState();
    const [isPopupOpen, setIsPopupOpen] = useState(false);


    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true)
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                const dropdownValues = owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
                }));
                setOwnersDropdownValues(dropdownValues);

                const { role } = await getUserRole();
                setUserRole(role);
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const ownerFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Μονάδα εκτροφής προβατίνας",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Συνέχεια",
        },
    ]

    const handleOwnerSubmit = async (values) => {
        setIsLoading(true);
        const ownerId = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner)?._id;
        const { success: scs, animals, message } = await getUdderAnimals(ownerId);
        if (scs) {
            setFetchedAnimals(animals);
            setAnimalsDropdownValues(animals.map((animal) => ({
                value: `${animal.registrationCode}`,
                text: `${animal.registrationCode}`
            })));
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const animalFormContent = [
        {
            customType: "dropdown",
            id: "animal",
            items: animalsDropdownValues,
            placeholder: "Προβατίνα",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Συνέχεια",
        },
    ];

    const handleAnimalSubmit = async (values) => {
        setIsLoading(true);
        setSelectedAnimal(values.animal);
        const animalId = fetchedAnimals.find((animal) => animal.registrationCode === values.animal)?._id;
        const { success: scs, udders, message } = await getUdders(animalId);
        if (scs) {
            setFetchedUdders(udders);
            setUddersDropdownValues(udders.map((udder) => ({
                value: `${new Date(udder.testDate).toLocaleDateString("el-GR")}`,
                text: `${new Date(udder.testDate).toLocaleDateString("el-GR")}`,
            })));
            setStep(3);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const udderSelectFormContent = [
        {
            customType: "dropdown",
            id: "udder",
            items: uddersDropdownValues,
            placeholder: "Ημερομηνία Ελέγχου",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Συνέχεια",
        },
    ]

    const handleUdderSelectSubmit = (values) => {
        const udderObj = fetchedUdders.find((udder) => new Date(udder?.testDate).toLocaleDateString("el-GR") === values.udder);
        setSelectedUdder(udderObj);
        console.log(udderObj)
        setStep(4);
    }

    const gradeDropdownValues = [
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
        { text: 5, value: 5 },
        { text: 6, value: 6 },
        { text: 7, value: 7 },
        { text: 8, value: 8 },
        { text: 9, value: 9 },
        { text: 10, value: 10 },
    ];

    const udderFormContent = [
        {
            customType: "dropdown",
            id: "depth",
            items: gradeDropdownValues,
            placeholder: "Βάθος Μαστού",
            required: true,
            defaultValue: selectedUdder?.depth,
        },
        {
            customType: "dropdown",
            id: "teatAttachment",
            items: gradeDropdownValues,
            placeholder: "Πρόσφυση Μαστού",
            required: true,
            defaultValue: selectedUdder?.teatAttachment,
        },
        {
            customType: "dropdown",
            id: "shape",
            items: gradeDropdownValues,
            placeholder: "Σχήμα Μαστού",
            required: true,
            defaultValue: selectedUdder?.shape,
        },
        {
            customType: "dropdown",
            id: "position",
            items: gradeDropdownValues,
            placeholder: "Θέση Μαστού",
            required: true,
            defaultValue: selectedUdder?.position,
        },
        {
            customType: "dropdown",
            id: "size",
            items: gradeDropdownValues,
            placeholder: "Μέγεθος Μαστού",
            required: true,
            defaultValue: selectedUdder?.size,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή",
        },
    ];

    const handleUdderEditSubmit = async (values) => {
        setIsLoading(true);
        const { success: scs, message } = await updateUdder(selectedUdder?._id, values);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setStep(1);
        setIsLoading(false);
    }

    const handleDelete = async () => {
        setIsLoading(true);
        const { success: scs, message } = await deleteUdder(selectedUdder._id);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setIsPopupOpen(false);
        setStep(1);
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Διαγραφή στοιχείων μορφολογίας Μαστού"
                titleColor="black"
                onClose={() => setIsPopupOpen(false)}
                innerText={`Είστε σίγουροι ότι θέλετε να διαγράψετε τα στοιχεία μορφολογίας Μαστού για το ζώο με κωδικό Γενεαλογικού Βιβλίου "${selectedAnimal}";`}
                declineText="Πίσω"
                onDecline={() => setIsPopupOpen(false)}
                acceptText="Ναι, Διαγραφή Στοιχείων"
                onAccept={() => handleDelete()}
            />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    {step === 1 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλογή εκτροφής"}
                            </Typography>
                            <Form
                                content={ownerFormContent}
                                onSubmit={handleOwnerSubmit}
                                toResetForm={false}
                            />
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλογή Προβατίνας"}
                            </Typography>
                            <Form
                                content={animalFormContent}
                                onSubmit={handleAnimalSubmit}
                                toResetForm={false}
                            />
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλογή Ελέγχου"}
                            </Typography>
                            <Form
                                content={udderSelectFormContent}
                                onSubmit={handleUdderSelectSubmit}
                                toResetForm={false}
                            />
                        </>
                    )}
                    {step === 4 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {`Στοιχεία Μορφολογίας Μαστού - ${selectedAnimal}`}
                            </Typography>
                            <Form
                                content={udderFormContent}
                                onSubmit={handleUdderEditSubmit}
                                toResetForm={false}
                            />
                            {userRole === "ADMIN" && (
                                <Box sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => setIsPopupOpen(true)}
                                    >
                                        <DeleteIcon />
                                    </IconButton >
                                </Box>
                            )}
                        </>
                    )}
                    {step !== 1 && (
                        <BackButton onClick={() => setStep(step - 1)} />
                    )}
                </Box>
            </Box>
        </>
    )
}

export default memo(UdderEdit);